// Module
var code = "<div class=\"splash-message text-center\" data-bind=\"text: _labels.NO_CONTROLS_OF_TYPE_INVOICING\"></div>";
// Exports
export default code;